import { Component, OnDestroy, OnInit } from '@angular/core';
import { RecordService } from 'app/main/services/record.service';
import { DatasetActionContainerService } from 'app/main/services/datasetACS';
import { Observable, of, Subject } from 'rxjs';
import { BasePageDirective } from '../base-page';
import { ActivatedRoute, Router } from '@angular/router';
import { AppService } from 'app/main/services/app.service';
import { takeUntil } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { DatasetService } from 'app/main/services/dataset.service';
import { BaseLanguageLoaderComponent } from '../base-language-loader.component';

export interface IListProducts{
	current_page: number;
	data: any[];
	first_page_url: string;
	from: number;
	last_page: number;
	last_page_url: string;
	next_page_url: string;
	path: string;
	per_page: number;
	prev_page_url: string;
	to: number;
	total: number;
}

@Component({
	selector: 'list-products-page',
	templateUrl: './list-products.page.html',
	styleUrls: ['./list-products.page.scss']
})
export class ListProductsPageComponent extends BaseLanguageLoaderComponent implements OnInit, OnDestroy{

	_unsubscribeAll: Subject<any>;
	_isLoading: boolean;
	_response: IListProducts;

	constructor(
		public recordService: RecordService, 
		public appService: AppService,
		protected datasetService: DatasetService,
		protected activatedRoute: ActivatedRoute,
		protected router: Router,
		public translate: TranslateService) {
			super(appService, translate);
			this._unsubscribeAll = new Subject<any>();
		}

	ngOnInit(): void {
		super.ngOnInit();
		/** caricamento dati */
		this.load();
		// reload data with new language
		this.appService.onLanguageChange
		.pipe(takeUntil(this._unsubscribeAll))
		.subscribe((newLang) => {
			if (newLang) this.load();
		});
	}

	ngOnDestroy(): void{
		this._unsubscribeAll.next();
		this._unsubscribeAll.complete();
	}

	onChangePage(page: number): void{
		this.load({page: page});
	}

	protected load(extraParams: any = {}): void{
		this._isLoading = true;
		this.datasetService
		.get<IListProducts>('/list', Object.assign({}, extraParams))
		.subscribe({
			next: (response) => {
				this.onLoaded(response);
				this._isLoading = false;
			},
			error: (errorResp) => {
				this._isLoading = false;
				console.error('record.service.ts', errorResp);
			}
		});
	}

	protected onLoaded(response): void{
		this._response = response;
	}

	//#region properties
	get showPagination(): boolean{
		if(this._response.last_page && this._response.current_page && this._response.last_page > 1){
			return (this._response.last_page >= this._response.current_page);
		}
		return false;
	}
	//#endregion properties
}
